import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/movie";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full max-w-[960px] mx-auto px-4 md:px-8 py-16 md:py-24">
        <SectionHeading
          eyebrow="FAQ"
          title="常见问题"
          description="关于这部影片，观众最常提出的几个问题。"
        />

        <div className="mt-12 space-y-3">
          {faqs.map((item, index) => {
            const isOpen = open === index;
            return (
              <div
                key={item.q}
                className={`rounded-lg border transition-colors ${
                  isOpen ? "border-primary-300 bg-primary-50" : "border-background-200 bg-background-50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : index)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 text-left px-5 md:px-6 py-4 md:py-5 cursor-pointer"
                >
                  <span className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                    {item.q}
                  </span>
                  <i
                    className={`ri-add-line text-xl shrink-0 transition-transform duration-300 ${
                      isOpen ? "rotate-45 text-primary-600" : "text-foreground-400"
                    }`}
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 md:px-6 pb-5 text-sm md:text-base text-foreground-700 leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}